module.exports = __webpack_public_path__ + "img/138-6b216b.png";